module.exports = __webpack_public_path__ + "static/media/Scout-Haunted-Cover-4.5e725873.jpg";